module.exports = __webpack_public_path__ + "img/bg.7d9cc69a.png";